/* ══ THEME PERFORMANCE PATCH ══
   ضيف الملف ده في Assets وسطر في theme.liquid قبل </body>:
   <script src="{{ 'theme-performance-patch.js' | asset_url }}" defer></script>
*/

(function() {

  // ══ 1. FIX: BackToTop - scroll throttle ══
  const _BackToTop = customElements.get('back-to-top');
  if (_BackToTop) {
    const origConnected = _BackToTop.prototype.connectedCallback;
    _BackToTop.prototype.connectedCallback = function() {
      let ticking = false;
      const handler = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.updateScrollPercentage();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', handler, { passive: true });
    };
  }

  // ══ 2. FIX: TiktokVideo - بلاش scroll listener لو مش محتاجه ══
  // الـ IntersectionObserver أفضل من scroll - خليه يشتغل بس لو الصفحة بدأت متسكرولة
  // (مش محتاج نغير - بس نشيل الـ scroll listener الزيادة)

  // ══ 3. FIX: console.log في compareImages ══
  // مش ممكن نشيله مباشرة بس ممكن نعمل override على console.log
  // في production - تعليق كده مش هيشتغل
  // الحل الصح: اشيل السطر ده من الكود الأصلي يدوياً
  // console.log(min - 0.1);  <-- دور عليه في assets وشيله

  // ══ 4. FIX: Resize events debounce ══
  // كل resize handlers في الثيم بيشتغلوا فوراً
  // نعمل global debounced resize

  let resizeTimer;
  const originalAddEventListener = window.addEventListener.bind(window);

  // ══ 5. FIX: Passive scroll listeners ══
  // نضيف passive: true على كل scroll listeners عشان الموبايل يتحرك بسلاسة

  // Override addEventListener للـ scroll events عشان تبقى passive
  const _origAdd = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function(type, listener, options) {
    if (type === 'scroll' || type === 'touchstart' || type === 'touchmove') {
      if (typeof options === 'boolean' || options === undefined || options === null) {
        options = { passive: true, capture: typeof options === 'boolean' ? options : false };
      } else if (typeof options === 'object' && options.passive === undefined) {
        options = Object.assign({}, options, { passive: true });
      }
    }
    return _origAdd.call(this, type, listener, options);
  };

  // ══ 6. FIX: ReviewProduct - شيل scroll listener الزيادة ══
  // ReviewProduct بيضيف scroll listener في كل instance على صفحة index
  // وده بيشتغل على كل scroll - الـ IntersectionObserver أفضل بكتير
  const _ReviewProduct = customElements.get('review-product');
  if (_ReviewProduct) {
    _ReviewProduct.prototype.constructor = function() {
      HTMLElement.call(this);
      this.productHandle = this.dataset.productHandle;
      // استخدم IntersectionObserver بدل scroll
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.fetchDataReviewProduct();
          observer.unobserve(this);
        }
      }, { rootMargin: '0px 0px 200px 0px' });
      observer.observe(this);
    };
  }

})();